import React from 'react'
import { InfoWindow } from "react-google-maps"
import Card from '../Card/Card.jsx'


export default ({ restaurant }) => {

  return (
    <InfoWindow>
      <Card restaurant={restaurant} view="mapCard"/>
    </InfoWindow>
  )
}